import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { DialogButtonState } from '../DialogButtonState';

@Component({
    selector: 'srp-question-dialog',
    templateUrl: './srp-question-dialog.component.html',
    styleUrls: ['./srp-question-dialog.component.scss'],
    standalone: false,
})

export class SrpQuestionDialogComponent {
    title: string;
    message: string;
    choices: DialogButtonState[];
    styles: NgStyleValue;
    mainStyles: NgStyleValue;
    closeVisible: boolean;

    constructor(
        public dialogRef: MatDialogRef<SrpQuestionDialogComponent>,
    ) { }

    OnButtonClick(choice: string | DialogButtonState): void {
        this.dialogRef.close(this.getChoiceValue(choice));
    }

    getColor(choice: string | DialogButtonState): MatColor {
        return typeof choice === 'string' ? 'primary' : choice.color;
    }

    getChoice(choice: string | DialogButtonState): string {
        return typeof choice === 'string' ? choice : choice.title;
    }

    getChoiceValue(choice: string | DialogButtonState): string {
        return typeof choice === 'string' ? choice : choice.value ?? choice.title;
    }

    close(): void {
        this.dialogRef.close();
    }
}
